const Backbone = require('backbone');
const dustjs = require('dustjs');
const _closeMenuDust = require('common/_close_menu.dust');

module.exports = Backbone.View.extend({
	el: 'body',
	initialize: function(options = {}) {
		this.options = options;
		/*
         openButton - The selector of button that opens menu
         closeContainer - The selector of container to add close X button floated right
         menuContainer - The selector of the container that contains menu
         contentContainer - The selector of the container that excludes header
         */

		this.$underlay = this.$('.js-facet-underlay');

		this.events = this.events || {};
		this.events[`click ${this.options.openButton}`] = 'toggleMenu';
		this.events[`click ${this.options.contentContainer} .js-toggle-menu`] = 'toggleMenu';
		this.events[`click ${this.options.closeContainer} .js-toggle-menu`] = 'toggleMenu';
		this.events[`click ${this.options.menuContainer} .js-feedback`] = '_launchFeedback';
		this.delegateEvents();

		this.$menu = $(this.options.menuContainer);
		this.isOpen = this.$menu.hasClass('open');

		this.$overlay = this.$('.overlay');
		if (this.$overlay.length === 0) {
			this.overlay = this.$el.append($('<div class="overlay dark"></div>'));
		}
		this.render();
	},
	toggleMenu: function(e) {
		if (e) {
			e.preventDefault();
		}

		this.$menu.toggleClass('open');
		this.$el.toggleClass('noscroll');
		this.isOpen = this.$menu.hasClass('open');
		if (!this.$menu.hasClass('full')) {
			this.$overlay.toggleClass('show');
		}
		// new LDI mobile facets have underlay
		if (this.$underlay) {
			this.$underlay.toggleClass('dn');
		}
	},
	_launchFeedback: function() {
		window.usabilla_live('click');
	},
	render: function() {
		dustjs.render(_closeMenuDust, {}, (error, markup) => {
			if (!error) {
				this.$(this.options.closeContainer).append(markup);
			}
		});
	}
});
